import { useTranslation } from 'react-i18next';
import Toast from '@standardsdigital/ui-components/Toast';
import { useAppSelector } from '@/redux/hooks';
import { selectToastMessages } from '@/redux/slices/messageSlice';

function ToastWrapper() {
  const { t } = useTranslation();
  const messages = useAppSelector(selectToastMessages);

  return <Toast accessibleLabel={t('global.notifications')} messages={messages} />;
}

export default ToastWrapper;
